if (!customElements.get('trust-bar-icons')) {
  customElements.define(
    'trust-bar-icons',
    class TrustBarIcons extends HTMLElement {
      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.grid = this.querySelector('.gh-tbar__grid');
        this.items = Array.from(this.querySelectorAll('.gh-tbar__item'));
        this.pagination = this.querySelector('.swiper-pagination');
        if (!this.enableSlider || !this.grid || this.items.length === 0) return;

        this.sliderInstance = false;
        this.mql = window.matchMedia('(max-width: 767px)');
        this.boundInit = this.init.bind(this);
        this.init();

        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.boundInit);
        } else if (this.mql.addListener) {
          this.mql.addListener(this.boundInit);
        }
      }

      init() {
        if (this.mql.matches) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        if (!window.FoxTheme || !FoxTheme.Carousel) return;

        const perView = parseFloat(this.dataset.perView) || 1;

        const options = {
          slidesPerView: perView,
          spaceBetween: 16,
          centeredSlides: true,
          loop: this.dataset.loop === 'true',
          threshold: 2,
          grabCursor: true,
          watchOverflow: true,
        };

        if (this.dataset.dots === 'true' && this.pagination) {
          options.pagination = { el: this.pagination, clickable: true };
        }

        let modules = null;
        const delay = parseInt(this.dataset.autoplaySpeed);
        if (this.dataset.autoplay === 'true' && delay > 0) {
          modules = [FoxTheme.Swiper.Autoplay];
          options.autoplay = { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true };
        }

        this.classList.add('swiper');
        this.grid.classList.add('swiper-wrapper');
        this.items.forEach((item) => item.classList.add('swiper-slide'));
        if (this.pagination) this.pagination.hidden = false;

        this.sliderInstance = new window.FoxTheme.Carousel(this, options, modules);
        this.sliderInstance.init();
      }

      destroySlider() {
        this.classList.remove('swiper');
        this.grid.classList.remove('swiper-wrapper');
        this.items.forEach((item) => item.classList.remove('swiper-slide'));
        if (this.pagination) this.pagination.hidden = true;
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
